import { gql } from '@apollo/client';

/**
 * GraphQL mutation for creating a new community
 */
export const CREATE_COMMUNITY = gql`
  mutation CreateCommunity($input: CreateCommunityInput!) {
    createCommunity(input: $input) {
      id
      name
      communityGroupId
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
      }
      securityGroups {
        admin
        moderator
        user
      }
    }
  }
`;
